// extracted by mini-css-extract-plugin
export default {"errorMsg":"Choice_errorMsg__vaxb5","mainContainer":"Choice_mainContainer__0rabo","redirectButtons":"Choice_redirectButtons__cPfoI"};